import React from  'react';
import './Toggle.scss';
import PropTypes from 'prop-types';

const ToggleSwitch = ({value,changeView,meta_id}) => {
    return (
        <React.Fragment>
            <label className="switch">
                <input className="check" type="checkbox" checked={value}  onChange = {changeView} />
                <span meta-id={'toggle_'+meta_id} className="slider round"></span>
            </label>
        </React.Fragment>
    )
}

export default ToggleSwitch;

ToggleSwitch.propTypes = {
    value: PropTypes.bool.isRequired,
    changeView: PropTypes.func,
    meta_id: PropTypes.string.isRequired,
}

ToggleSwitch.defaultProps = {
    value: false,
    changeView: () => 'toggle',
    meta_id: 'toggle',
}

export const ToggleUI = ({value,changeView,meta_id,text,clas,disable}) => {
    
    return (
        <React.Fragment>
            <label className={`switch_text ${clas}`}>
                <input className="check" type="checkbox" checked={value}  onChange = {changeView} disabled={disable} />
                <span meta-id={'toggle_'+meta_id} className={`slider round ${disable?'disable':''}`}>
                    {text.length?<span className="toggle_text">{value?text[0] || "Published":text[1] || "Unpublished"}</span>:null}
                </span>
            </label>
        </React.Fragment>
    )
}

ToggleUI.propTypes = {
    value: PropTypes.bool.isRequired,
    disable: PropTypes.bool.isRequired,
    changeView: PropTypes.func,
    meta_id: PropTypes.string.isRequired,
    clas: PropTypes.string.isRequired,
    text: PropTypes.array.isRequired,
}

ToggleUI.defaultProps = {
    value: false,
    disable: false,
    changeView: () => 'toggle',
    meta_id: 'toggle_data',
    text: [],
    clas: ''
}
